import axios from 'axios';
import React from 'react'
import { api } from '../../settings/env';
import Swal from 'sweetalert2';

export default function SettingsPlus() {

    function calcularHorasEntreTiempos(tiempoInicial, tiempoFinal) {
        // Convertir tiempo inicial a minutos
        const partesTiempoInicial = tiempoInicial.split(':');
        const minutosInicial = parseInt(partesTiempoInicial[0]) * 60 + parseInt(partesTiempoInicial[1]);

        // Convertir tiempo final a minutos
        const partesTiempoFinal = tiempoFinal.split(':');
        const minutosFinal = parseInt(partesTiempoFinal[0]) * 60 + parseInt(partesTiempoFinal[1]);

        // Calcular la diferencia en minutos
        let diferenciaMinutos = minutosFinal - minutosInicial;

        // Asegurarse de que la diferencia sea positiva
        if (diferenciaMinutos < 0) {
            diferenciaMinutos += 24 * 60; // Añadir 24 horas en minutos si la diferencia es negativa
        }

        // Convertir la diferencia a horas
        const horas = diferenciaMinutos / 60;

        return horas;
    }

    function dividirHorasEnIntervalos(horaInicio, horaFin, minutosIntervalo) {
        // Convertir las horas de inicio y fin a minutos
        const [horasInicio, minutosInicio] = horaInicio.split(':').map(Number);
        const totalMinutosInicio = horasInicio * 60 + minutosInicio;
      
        const [horasFin, minutosFin] = horaFin.split(':').map(Number);
        const totalMinutosFin = horasFin * 60 + minutosFin;
      
        // Calcular la diferencia total en minutos
        let diferenciaMinutos = totalMinutosFin - totalMinutosInicio;
      
        // Asegurarse de que la diferencia sea positiva
        if (diferenciaMinutos < 0) {
          diferenciaMinutos += 24 * 60; // Añadir 24 horas en minutos si la diferencia es negativa
        }
      
        // Calcular el número de intervalos
        const numIntervalos = Math.floor(diferenciaMinutos / minutosIntervalo);
      
        // Generar los intervalos de tiempo
        const intervalos = [];
        for (let i = 0; i <= numIntervalos; i++) {
          const minutosActuales = totalMinutosInicio + i * minutosIntervalo;
          const horas = Math.floor(minutosActuales / 60) % 24; // Asegurar que las horas estén en el rango 0-23
          const minutos = minutosActuales % 60;
          intervalos.push(`${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`);
        }
      
        return intervalos;
      }
      
      // Ejemplo de uso
      const horaInicio = '10:00';
      const horaFin = '14:30';
      const minutosIntervalo = 30;
      
      const intervalos = dividirHorasEnIntervalos(horaInicio, horaFin, minutosIntervalo);
      console.log(intervalos);
      // Salida: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30']
      
      const intervalos2 = dividirHorasEnIntervalos("23:00", "01:00", 15);
      
      console.log(intervalos2);
      //salida: ['23:00', '23:15', '23:30', '23:45', '00:00', '00:15', '00:30', '00:45', '01:00']

    const save = () => {
        const aperturaEl = document.getElementById("apertura");
        const cierreEl = document.getElementById("cierre");
        const minutesEl = document.getElementById("minutes");
        const id = localStorage.getItem("vitaly_userid");

        console.log(aperturaEl.value, cierreEl.value);
        console.log(dividirHorasEnIntervalos(aperturaEl.value, cierreEl.value, minutesEl.value))

        const bloques = dividirHorasEnIntervalos(aperturaEl.value, cierreEl.value, minutesEl.value)

        axios.patch(`${api}/register/${id}/times`, {times: bloques})
        .then(resp => {
            console.log("Chevere", resp.data)

            Swal.fire({
                title: "Guardado",
                icon: "success",
                draggable: true
              });
        })
        .catch(err => console.error(err))
        

    }

    return (
        <div className='page-admin container my-4'>
            <p>Hora de apertura:</p>


            <input type="time" id='apertura' />

            <p className='my-4'>Hora de cierre:</p>

            <input type="time" id='cierre' />

            <p className='my-4'>Intervalos  (minutos):</p>

            <input type="number" placeholder='Minutos' id='minutes' />

            <br /><br />

            <button className='btn btn-primary' onClick={save}>
                Guardar
            </button>
        </div>
    )
}
